import { render } from "./OapImmersiveBeforeAfterVideo.vue?vue&type=template&id=5e471cf4"
import script from "./OapImmersiveBeforeAfterVideo.vue?vue&type=script&lang=js"
export * from "./OapImmersiveBeforeAfterVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__